/* Adds Netlify deploy status badge to the top of the CMS */

const badgeSrc = () => `https://api.netlify.com/api/v1/badges/a798b552-6380-4437-ad4d-88c5f47957fd/deploy-status?${(new Date()).getTime()}`
const badgeClass = "deploy-status-badge"
let added = false

const refreshBadge = () => {
  const badge = document.querySelector("." + badgeClass)
  badge.src = ""
  badge.src = badgeSrc()
}

const addBadge = () => {
  const target = document.querySelector("header > div > div")

  if(target) {
    // disconnect observer once target is found
    observer.disconnect()

    if(!added) {
      const badge = document.createElement("img")
      badge.classList.add(badgeClass)
      badge.src = badgeSrc()
      badge.style.marginRight = "32px"

      target.prepend(badge)

      // refresh the badge every 5 seconds
      setInterval(refreshBadge, 5000)

      added = true
    }
  }
}

// watch for mutations to the DOM as the CMS app loads
const observer = new MutationObserver(addBadge)
observer.observe(document.body, { attributes: true, childList: true, subtree: true })